module.exports = __webpack_public_path__ + "img/top1.94cd270.png";